import type { Ability } from '../../CharacterTypes';
import { DEV_CALLING } from '../devCalling';

/** The dev calling in the shared class-config shape. Its abilities come from the `[dev]` TOML kit, not here. */
export const DEV_CONFIG = {
  name: DEV_CALLING.name,
  description: DEV_CALLING.description,
  baseStats: DEV_CALLING.baseStats,
  healthMultiplier: DEV_CALLING.healthMultiplier,
  manaMultiplier: DEV_CALLING.manaMultiplier,
  color: DEV_CALLING.color,
  movementStats: DEV_CALLING.movementStats,
  abilities: [] as Ability[],
};
